"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9533],{

/***/ 59533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20.2 15c-.2 0-4.4-1.1-7.2 1l-.1.1V14c3.8-.3 6-2.5 6-6V3c0-.4-.2-.8-.6-.9-.3-.2-.7-.1-1 .2L15 4.6l-2.3-2.3c-.4-.4-1-.4-1.4 0L9 4.6 6.7 2.3c-.3-.3-.7-.4-1.1-.2-.4.1-.6.5-.6.9v5c0 3.5 2.2 5.6 6 6v2.2l-.1-.1c-2.7-2.1-7-1.1-7.2-1-.4 0-.7.4-.7.9 0 1.8.6 3.2 1.8 4.2 1.8 1.6 4.4 1.8 6 1.8.6 0 1 0 1.2-.1.2 0 .7.1 1.2.1 1.6 0 4.2-.3 6-1.8 1.2-1 1.8-2.5 1.8-4.2 0-.5-.3-.9-.8-1zM7 8V5.4l1.3 1.3c.4.4 1 .4 1.4 0L12 4.4l2.3 2.3c.4.4 1 .4 1.4 0L17 5.4V8c0 3.3-2.7 4-5 4s-5-.7-5-4zm-.9 10.7c-.6-.5-.9-1.1-1-1.9 1.2-.2 3.3-.2 4.6.8.7.5 1.1 1.3 1.3 2.4-1.5.1-3.6-.1-4.9-1.3zm11.8 0c-1.3 1.2-3.6 1.3-4.8 1.3.1-1.1.6-1.9 1.3-2.4 1.4-1.1 3.5-1 4.6-.8-.2.8-.5 1.4-1.1 1.9z"
}), "Garden"));


/***/ })

}]);